import { app } from '../../../app';

app.factory('CompanyRegistration', CompanyRegistration);

/** @ngInject */
function CompanyRegistration($resource) {
    return $resource('app/rest/companyRegistration', {}, {
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/company-registration/company-registration.service.js